module.exports = __webpack_public_path__ + "static/media/basket-ball.b143dd9b.png";